import { Button, Text } from '@react-spectrum/s2';
import ChevronRight from '@react-spectrum/s2/icons/ChevronRight';
import { useCallback, useState } from 'react';

import { TypewriterOnce } from '../components/TypewriterOnce';

type BackgroundIntroScreenProps = {
	onContinue: () => void;
};

export const BackgroundIntroScreen = ({
	onContinue,
}: BackgroundIntroScreenProps) => {
	const [typingDone, setTypingDone] = useState(false);
	const handleTypingDone = useCallback(() => setTypingDone(true), []);

	return (
		<div className="flex h-full w-full items-center justify-center">
			<div className="w-full max-w-[760px] px-8">
				<h2
					className="mb-8"
					style={{
						fontSize: 'clamp(26px, 4vw, 40px)',
						fontWeight: 700,
						letterSpacing: '-0.02em',
						lineHeight: 1.15,
						color: 'var(--text-primary)',
					}}
				>
					<TypewriterOnce
						text="To do this, I'm always working in the background for you."
						onDone={handleTypingDone}
					/>
				</h2>

				<div
					style={{
						opacity: typingDone ? 1 : 0,
						transition: 'opacity 400ms ease',
						pointerEvents: typingDone ? 'auto' : 'none',
					}}
				>
					<p
						className="mb-6"
						style={{
							fontSize: 18,
							lineHeight: 1.5,
							color: 'var(--text-primary)',
						}}
					>
						Sometimes that&apos;s a{' '}
						<strong style={{ fontWeight: 700 }}>Job</strong> — watching similar
						businesses in your space, listening to what people are saying
						online, surfacing what&apos;s worth knowing.
					</p>

					<p
						className="mb-6"
						style={{
							fontSize: 18,
							lineHeight: 1.5,
							color: 'var(--text-primary)',
						}}
					>
						Sometimes that&apos;s a{' '}
						<strong style={{ fontWeight: 700 }}>Campaign</strong> — posting,
						replying, reaching new people on your behalf.
					</p>

					<p
						className="mb-10"
						style={{
							fontSize: 18,
							lineHeight: 1.5,
							color: 'var(--text-primary)',
						}}
					>
						Jobs run quietly. Campaigns show up where your customers see them.
					</p>

					<Button
						variant="primary"
						staticColor="black"
						fillStyle="fill"
						size="L"
						onPress={onContinue}
					>
						<Text>Makes sense</Text>
						<ChevronRight />
					</Button>
				</div>
			</div>
		</div>
	);
};
